import React from "react"
import styled from "styled-components"
import { CalculationSchemaKeys } from "src/features/calculator/schema"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"
import { StylesConfig } from "react-select"

export type Option = { value: string | number; label: string }

const selectCustomStyles = (width?: string): StylesConfig<Option, false> => ({
  container: (provided: any) => ({
    ...provided,
    width: width || "200px", // 全体の幅を指定
  }),
  control: (provided: any) => ({
    ...provided,
    width: width || "200px", // コントロール部分の幅を指定
  }),
})

type Props = {
  options: Option[]
  errorText?: string
  name: CalculationSchemaKeys
  label: string
  hint?: string
  isSearchable?: boolean
  required?: boolean
  defaultValue?: Option
  value?: Option
  onChange: (option: Option | null) => void
  width?: string
}

type BaseSelectFieldProps = Props & {
  SelectComponent: typeof Select | typeof CreatableSelect
}

function BaseSelectField({
  options,
  errorText,
  name,
  label,
  hint,
  isSearchable = false,
  required = false,
  defaultValue,
  value,
  onChange,
  width,
  SelectComponent,
}: BaseSelectFieldProps) {
  return (
    <StyledFieldWrapperDiv>
      <label id={`${name}-label`}>
        {label} {required && <span>*</span>}
      </label>
      <SelectComponent
        aria-labelledby={`${name}-label`}
        aria-required={required}
        aria-invalid={!!errorText}
        classNamePrefix="select"
        value={value}
        defaultValue={defaultValue}
        isSearchable={isSearchable}
        name={name}
        options={options}
        styles={selectCustomStyles(width)}
        onChange={onChange}
      />
      <span>{hint}</span>
      {errorText && (
        <StyledErrorSpan role="alert" aria-live="polite">
          {errorText}
        </StyledErrorSpan>
      )}
    </StyledFieldWrapperDiv>
  )
}

export function SelectField(props: Props) {
  return <BaseSelectField {...props} SelectComponent={Select} />
}

export function CreatableSelectField(props: Props) {
  return <BaseSelectField {...props} SelectComponent={CreatableSelect} />
}

const StyledFieldWrapperDiv = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

const StyledErrorSpan = styled("span")`
  color: red;
`
